module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ebook"
    }
  }, [(_vm.currentPage.width && _vm.currentPage.height) ? _c('div', {
    staticClass: "page"
  }, [_c('svg', {
    attrs: {
      "viewBox": '0 0 ' + _vm.currentPage.width + ' ' + _vm.currentPage.height
    }
  }, [_vm._l((_vm.currentPage.actions), function(action) {
    return [_vm._l((action.clickRegions), function(region) {
      return [_c('polygon', {
        attrs: {
          "points": _vm.toPointString(region.points)
        },
        on: {
          "click": function($event) {
            return _vm.playAudioFile(action.mediaPath, action.mtc)
          }
        }
      })]
    })]
  })], 2), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.currentPage.path,
      "width": "100%"
    }
  }), _vm._v(" "), (_vm.page > 1) ? _c('span', {
    staticClass: "page-left",
    on: {
      "click": function($event) {
        return _vm.pageLeft()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left"
  })]) : _vm._e(), _vm._v(" "), (_vm.page < _vm.pages.length) ? _c('span', {
    staticClass: "page-right",
    on: {
      "click": function($event) {
        return _vm.pageRight()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-right"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "mt-3",
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [(_vm.pdf) ? _c('span', {
    staticClass: "float-left"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "href": _vm.pdf,
      "download": ""
    }
  }, [_vm._v("檔案下載")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "pagination justify-content-end"
  }, _vm._l((_vm.pages.length), function(n) {
    return _c('li', {
      staticClass: "page-item",
      class: {
        'active': _vm.page === n
      }
    }, [_c('a', {
      staticClass: "page-link",
      on: {
        "click": function($event) {
          _vm.page = n
        }
      }
    }, [_vm._v(_vm._s(n))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ce0168b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/Ebook.vue
// module id = 756
// module chunks = 3